<template>
  <div class="event-report-form py-1">
    <v-row>
      <v-col cols="12" md="6">
        <v-row align="center">
          <v-col cols="12">
            <v-menu
              ref="timeFrom"
              v-model="timeFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="form.real_time_from"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.real_time_from"
                  name="real_time_from"
                  :label="`${$t('PLANNINGS.TIME_FROM')} *`"
                  prepend-icon="mdi-clock-time-four-outline"
                  :clearable="!readonly"
                  readonly
                  :rules="getRulesByName('real_time_from')"
                  :error-messages="errors.real_time_from"
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="updateValue('real_time_from', null)"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="timeFrom"
                v-model="form.real_time_from"
                :allowed-minutes="allowedStep"
                :max="form.real_time_to"
                :readonly="readonly"
                format="24hr"
                scrollable
                @click:minute="$refs.timeFrom.save(form.real_time_from)"
                @input="updateValue('real_time_from', $event)"
              ></v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-menu
              ref="timeTo"
              v-model="timeTo"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="form.real_time_to"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.real_time_to"
                  name="real_time_to"
                  prepend-icon="mdi-clock-time-four-outline"
                  :label="`${$t('PLANNINGS.TIME_TO')} *`"
                  :rules="getRulesByName('real_time_to')"
                  :error-messages="errors.real_time_to"
                  :clearable="!readonly"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="updateValue('real_time_to', null)"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="timeTo"
                v-model="form.real_time_to"
                :allowed-minutes="allowedStep"
                format="24hr"
                :min="form.real_time_from"
                :readonly="readonly"
                scrollable
                @click:minute="$refs.timeTo.save(form.real_time_to)"
                @input="updateValue('real_time_to', $event)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <p class="text-subtitle-1 text--secondary">
              <strong class="mr-2">{{ $t('ITEM.DURATION') }}:</strong>
              <span>{{ duration }}</span>
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="form.notes"
              name="notes"
              :rows="3"
              :label="$t('PLANNINGS.NOTES')"
              :readonly="readonly"
              :rules="getRulesByName('notes')"
              :error-messages="errors.notes"
              outlined
              @input="updateValue('notes', $event)"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.invoice_note"
              name="notes"
              :rows="1"
              :readonly="readonly"
              :counter="50"
              :label="$t('EREPORTER.INVOICES.INVOICE_NOTE')"
              :rules="getRulesByName('invoice_note')"
              :error-messages="errors.invoice_note"
              outlined
              @input="updateValue('invoice_note', $event)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import duration from '@/modules/_global/mixins/duration-time';
import formEditable from '@/modules/_global/mixins/form-editable';
import eventFrom from './mixins/event-form';
import { maxLength, notEmpty } from '@/modules/_global/variables/rules';

export default {
  name: 'EventReportForm',

  mixins: [eventFrom, formEditable, duration],

  data() {
    return {
      timeFrom: false,
      timeTo: false,
      form: {
        real_time_from: null,
        real_time_to: null,
        notes: '',
        invoice_note: ''
      },
      rules: {
        real_time_from: [notEmpty],
        real_time_to: [notEmpty],
        invoice_note: [maxLength(50)]
      }
    };
  },

  computed: {
    duration() {
      return this.getDuration(this.form.real_time_from, this.form.real_time_to);
    }
  },

  mounted() {
    this.form.real_time_from = this.form.real_time_from || this.form.time_from;
    this.form.real_time_to = this.form.real_time_to || this.form.time_to;
  }
};
</script>

<style lang="scss">
.event-report-form {
  .row {
    margin-top: -4px;
    margin-bottom: -4px;

    & + .row {
      margin-top: 4px;
    }

    > .col,
    > [class*='col-'] {
      padding-top: 4px;
      padding-bottom: 4px;
    }

    &.no-gutters > .col,
    &.no-gutters > [class*='col-'] {
      padding: 0;
    }
  }
}
</style>
